import React, { Component } from 'react'
import { BrowserRouter as Router, Route, Switch, Redirect } from 'react-router-dom'
import functions from './utils/functions'
import Dashboard from './pages/Dashboard';
import Services from './pages/Services';
import AboutUs from './pages/AboutUs';
import Contact from './pages/Contact';
import 'react-app-polyfill/stable';
import 'react-app-polyfill/ie11';

import ReactDOM from 'react-dom/client'
import Doctor from './pages/Doctor';

// const root = ReactDOM.createRoot(document.getElementById('root'))

class App extends Component {


  state = {
    screen: "Login",
    loggedIn: true,
    accessInfo: functions.permissionGuard()
  }

  componentDidMount() {
    this.checkLogin();
  }

  checkLogin() {
    if (!localStorage.getItem("ntinda@user")) {
      this.setState({
        loggedIn: false
      })
    } else {
      this.setState({
        loggedIn: true
      })
    }
  }
  
  render() {
    const roleList = functions.roleGuard()
    const USER_BOUNDARY = functions.userBoundary();
    return (
      <Router forceRefresh={true}>
        <Switch>
          {/* {!this.state.loggedIn && <Route exact path="/" component={Home} />} */}

          

          <Route exact path="/" component={Dashboard} />
          <Route exact path="/our-services" component={Services} /> 
          <Route exact path="/about-us" component={AboutUs} />
          <Route exact path="/gallery" component={Contact} />
          <Route exact path="/doctor-profile" component={Doctor} />
          {/* <Route exact path="*" component={Error} />  */}

        </Switch>
      </Router>
    )
  }
}
export default App

